module.exports = __webpack_public_path__ + "static/img/yk8500.4fcf3f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk8500.png
// module id = 3aLx
// module chunks = 1